let styles = getComputedStyle(document.documentElement);
let xs = styles.getPropertyValue('--breakpoint-xs');
let sm = styles.getPropertyValue('--breakpoint-sm');
let md = styles.getPropertyValue('--breakpoint-md');
let lg = styles.getPropertyValue('--breakpoint-lg');
let xl = styles.getPropertyValue('--breakpoint-xl');

const pixelBreakpoints = {
  xs,
  sm,
  md,
  lg,
  xl,
};

const unitlessBreakpoints = {};
Object.entries(pixelBreakpoints).forEach(([key, val]) => {
  unitlessBreakpoints[key] = parseInt(val.replace('px', ''));
});

export { pixelBreakpoints, unitlessBreakpoints };
